const queries = {
  addresses: 'addresses',
  counterparties: 'counterparties',
  counterpartiesTypes: 'counterpartiesTypes',
  countries: 'countries',
  dadataAddresses: 'dadataAddresses',
  facilities: 'facilities',
  facility: 'facility',
  facilityFloors: 'facilityFloors',
  facilityMeters: 'facilityMeters',
  facilityTariffs: 'facilityTariffs',
  meterHistory: 'meterHistory',
  meterReading: 'meterReading',
  meterTariffTypes: 'meterTariffTypes',
  meterTypes: 'meterTypes',
  meters: 'meters',
  officesStates: 'officesStates',
  officesTypes: 'officesTypes',
  people: 'people',
  room: 'room',
  roomDescription: 'roomDescription',
  roomMeters: 'roomMeters',
  roomsCounterparty: 'roomsCounterparty',
  roomsInFacility: 'roomsInFacility',
  tariffsTypes: 'tariffsTypes',
  treeData: 'treeData',
  companyServices: 'companyServices',
};

export default queries;
